import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';
import { flexbox, justifyContent, alignSelf } from '../../styles/helpers/flexbox';

export const StudentLearningGapsWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  return `
    border: 1px solid ${colours.grey[400]};
    border-radius: 8px;
    margin: 10px 40px;
    box-sizing: border-box;
    padding: 10px;
  `;
});
export const Header = styled.div`
  ${flexbox()}
  ${justifyContent('space-between')}

  padding-left: 15px;
  padding-right: 10px;

  > :first-child {
    font-size: 18px;
    text-align: left;
    word-break: break-all;
  }

  > :last-child {
    ${alignSelf('flex-end')}
  }
`;

export const InfoContent = styled.div`

  padding-bottom: 2em;
`;

export const Body = styled.div`
  ${flexbox()}
  ${justifyContent('space-between')}
`;
